import styled from 'styled-components';
import Icon2 from '../../../../assets/images/blog/icon2.svg';

const BlogPageWrapper = styled.div`
  .single-post-wrapper {
    padding: 50px 0 180px 0;
  }
  .single-post-block {
    p {
      font-size: 16px;
      font-weight: 300;
      line-height: 29px;
      letter-spacing: 0.2px;
    }
    p + p {
      margin-top: 30px;
    }
    .entry-three {
      color: ${(props) => props.theme.headingColor};
      font-weight: 500;
    }
    &:hover {
      .post-thumb-block {
        img {
          transform: scale3d(1.1, 1.1, 1);
        }
      }
    }
  }
  .post-thumb-block {
    overflow: hidden;
    margin-bottom: 40px;
    position: relative;
    border-radius: 6px;
    .post-meta {
      padding: 15px 23px;
      border-radius: 6px;
      font-size: 15px;
      line-height: 20px;
      text-align: center;
      color: ${(props) => props.theme.white};
      width: 100px;
      background: rgba(255, 255, 255, 0.15);
      position: absolute;
      top: 10px;
      right: 10px;
      em {
        font-weight: 600;
        font-size: 28px;
        line-height: 35px;
        display: block;
        font-style: normal;
      }
    }
    img {
      width: 100%;
      transition: all 0.6s ease-in !important;
      border-radius: 6px;
    }
  }

  .post-title {
    font-size: 32px;
    font-weight: 600;
    line-height: 48px;
    letter-spacing: 1.5px;
    margin-bottom: 25px;
    display: block;
  }
  blockquote {
    padding-left: 90px;
    padding-bottom: 30px;
    background: transparent;
    overflow: hidden;
    font-size: 32px;
    line-height: 45px;
    border-radius: 6px;
    margin: 60px 0 40px 0;
    position: relative;
    box-sizing: border-box;
    position: relative;
    &:before {
      content: '';
      width: 60px;
      height: 3px;
      background: -moz-linear-gradient(45deg, #f3676d 0%, #fda44e 50%, #fda44e 51%, #fec945 100%);
      background: -webkit-linear-gradient(45deg, #f3676d 0%, #fda44e 50%, #fda44e 51%, #fec945 100%);
      background: linear-gradient(45deg, #f3676d 0%, #fda44e 50%, #fda44e 51%, #fec945 100%);
      -webkit-filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f3676d',endColorstr='#fec945',GradientType=1 );
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f3676d',endColorstr='#fec945',GradientType=1 );
      position: absolute;
      top: 20px;
      left: 0;
    }
    &:after {
      content: url(${Icon2});
      position: absolute;
      right: 0;
      bottom: -22px;
      transform: rotate(180deg);
      z-index: -1;
      opacity: 1;

      transition: all 1s ease-in-out;
    }

    span {
      display: block;
      font-size: 85%;
      margin-top: 10px;
      opacity: 0.8;
    }
  }
  .gradient-text {
    background-image: linear-gradient(45deg, #f3676d, #fec945);
    background-size: 100%;
    background-repeat: repeat;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-background-clip: text;
    -moz-text-fill-color: transparent;
  }
  .post-info-block {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 80px;
    margin-bottom: 80px;
    border-bottom: 1px solid rgba(253, 164, 78, 0.3);
    padding-bottom: 30px;
  }
  .single-page-tags {
    a {
      color: ${(props) => props.theme.primaryColor};
      margin-left: 10px;
      display: inline-block;
      padding: 6px 18px;
      border-radius: 3px;
      font: 400 13px/26px 'Poppins', sans-serif;
      transition: all 0.3s linear;
      background-image: linear-gradient(45deg, #f3676d, #fec945);
      background-size: 100%;
      background-repeat: repeat;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      -moz-background-clip: text;
      -moz-text-fill-color: transparent;
      &:hover {
        color: ${(props) => props.theme.primaryColor};
        background-image: linear-gradient(45deg, #f3676d, #fec945);
        background-size: 100%;
        background-repeat: repeat;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        -moz-background-clip: text;
        -moz-text-fill-color: transparent;
      }
    }
  }
  .share {
    display: flex;
    align-items: center;
    a {
      line-height: 100%;
      &:hover svg {
        color: ${(props) => props.theme.primaryColor};
      }
    }
    svg {
      font-size: 28px;
      color: ${(props) => props.theme.primaryColor};
      margin-right: 10px;
      line-height: 100%;
      transition: all 0.3s linear;
    }
  }
  .block-title {
    font-size: 36px;
    color: ${(props) => props.theme.headingColor};
    font-weight: 500;
    padding-bottom: 20px;
  }

  .comment-body-inner,
  .replay a {
    display: flex;
    align-items: center;
  }

  .post-comment-wrapper {
    padding-top: 40px;
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    li {
      ul {
        margin-left: 70px;
      }
    }
  }
  .post-comment-block {
    display: flex;
    padding: 50px 0 40px;
    border-bottom: 1px solid rgba(253, 164, 78, 0.3);
  }
  .author-avatar {
    min-width: 95px;
    padding-right: 15px;
    img {
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }
  }
  .comment-body-inner {
    justify-content: space-between;
    h3 {
      font-size: 20px;
      color: ${(props) => props.theme.textColor};
      font-weight: 400;
      padding-bottom: 5px;
      margin: 0;
      min-width: 110px;
      span {
        display: block;
        font-size: 15px;
        font-style: italic;
        background-image: linear-gradient(45deg, #f3676d, #fec945);
        background-size: 100%;
        background-repeat: repeat;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        -moz-background-clip: text;
        -moz-text-fill-color: transparent;
      }
    }
  }
  .replay {
    a {
      background-image: linear-gradient(45deg, #f3676d, #fec945);
      background-size: 100%;
      background-repeat: repeat;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      -moz-background-clip: text;
      -moz-text-fill-color: transparent;
      transition: all 0.3s linear;
      svg {
        font-size: 30px;
        transition: all 0.3s linear;
        color: ${(props) => props.theme.primaryColor};
      }
      &:hover {
        background-image: linear-gradient(45deg, #f3676d, #fec945);
        background-size: 100%;
        background-repeat: repeat;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        -moz-background-clip: text;
        -moz-text-fill-color: transparent;
        svg {
          transform: translateX(5px);
        }
      }
    }
  }

  .comment-content {
    padding-top: 10px;
    p {
      line-height: 25px;
      margin-bottom: 0;
    }
  }

  .comment-box-wrapper {
    padding-top: 120px;
    .block-title {
      padding-bottom: 23px;
    }
    p {
      margin-bottom: 40px;
    }
    input,
    textarea {
      color: ${(props) => props.theme.textColor};
      background: transparent;
      margin-bottom: 35px;
      padding: 18px 15px;
      border-radius: 9px;
      border: 1px solid rgba(253, 164, 78, 0.3);
      width: 100%;
      font-size: 16px;
      transition: all 0.3s linear;
      &::placeholder {
        color: #989ca2;
        opacity: 1;
      }

      &:-ms-input-placeholder {
        color: #989ca2;
      }

      &::-ms-input-placeholder {
        color: #989ca2;
      }
      &:focus {
        border-color: rgba(253, 164, 78, 0.3);
      }
    }

    textarea {
      resize: none;
    }

    .form-inline {
      display: flex;
      justify-content: space-between;

      input {
        flex-basis: 50%;

        &:first-child {
          margin-right: 25px;
        }
      }
    }
    button {
      width: 220px;
      border-radius: 9px;
      border: none;
      color: ${(props) => props.theme.white};
      transition: all 0.3s ease-in;
      background: -moz-linear-gradient(45deg, #f3676d 0%, #fda44e 50%, #fda44e 51%, #fec945 100%);
      background: -webkit-linear-gradient(45deg, #f3676d 0%, #fda44e 50%, #fda44e 51%, #fec945 100%);
      background: linear-gradient(45deg, #f3676d 0%, #fda44e 50%, #fda44e 51%, #fec945 100%);
      -webkit-filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f3676d',endColorstr='#fec945',GradientType=1 );
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f3676d',endColorstr='#fec945',GradientType=1 );
    }
  }

  @media only screen and (max-width: 912px) {
    .single-post-block {
      padding-bottom: 120px;
    }
    .single-post-wrapper {
      padding: 50px 0 100px 0;
    }
  }
  @media only screen and (max-width: 480px) {
    .post-info-block {
      display: block;
      .tags {
        margin-bottom: 40px;
      }
    }
    .post-comment-wrapper {
      li {
        ul {
          margin-left: 0;
        }
      }
    }
    .comment-box-wrapper {
      .form-inline {
        display: block;
        input {
          &:first-child {
            margin-right: 0;
          }
        }
      }
    }
    blockquote {
      padding-left: 0;
      &:before {
        content: none;
      }
    }
    .single-page-tags {
      margin-left: -15px;
      margin-bottom: 15px;
      a {
        padding: 6px 5px;
      }
    }
  }
  @media only screen and (max-width: 375px) {
    .post-title {
      font-size: 20px;
      line-height: 30px;
    }
    blockquote {
      font-size: 24px;
      line-height: 38px;
    }
    .block-title {
      font-size: 28px;
    }
  }
`;
export default BlogPageWrapper;
